import { render, staticRenderFns } from "./performance-report-summary.vue?vue&type=template&id=4a6be308"
import script from "./performance-report-summary.vue?vue&type=script&lang=js"
export * from "./performance-report-summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports